import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5fc5b8f2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc5b8f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc5b8f2')) {
      api.createRecord('5fc5b8f2', component.options)
    } else {
      api.reload('5fc5b8f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5fc5b8f2&scoped=true", function () {
      api.rerender('5fc5b8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/company/houseShop/index.vue"
export default component.exports